import { useState } from "react";

import { makeStyles } from "@material-ui/core/styles";
import {
  Card,
  Grid,
  Box,
  Typography,
  Divider,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@material-ui/core";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import componentStyles from "assets/theme/views/admin/react-bs-table.js";
import ImagePlaceholder from "components/Image/ImagePlaceholder";

const useStyles = makeStyles(componentStyles);

export default function ShoppingHistory({ isMobile500, salesHistoric }) {
  const classes = useStyles();
  const [expanded, setExpanded] = useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <Grid
      container
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "baseline",
      }}
    >
      <Grid item xs={12}>
        <Card classes={{ root: classes.cardRoot }} style={{ display: "flex" }}>
          <Grid item xs={12} style={{ marginTop: "0.75rem" }}>
            <Box component={Typography} variant="h3" marginBottom="0!important">
              <Box component="span">Histórico de Compras</Box>
            </Box>
          </Grid>
          <Divider style={{ margin: "0.85rem 0" }} />
          <Grid item xs={12}>
            {salesHistoric?.map((item) => (
              <Accordion
                key={item?.IdPedido}
                expanded={expanded === item?.IdPedido}
                onChange={handleChange(item?.IdPedido)}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <div
                    role="presentation"
                    style={{
                      display: "flex",
                      flexDirection: isMobile500 ? "column" : "row",
                    }}
                  >
                    <Typography variant="body2">
                      <span style={{ fontWeight: "600" }}>Canal: </span> App
                    </Typography>
                    <Typography
                      variant="body2"
                      style={{ margin: isMobile500 ? 0 : "0 1rem" }}
                    >
                      <span style={{ fontWeight: "600" }}>Pedido: </span>
                      {item?.IdPedido}
                    </Typography>
                    <Typography variant="body2">
                      <span style={{ fontWeight: "600" }}>Data: </span>
                      {item?.Data}
                    </Typography>
                  </div>
                </AccordionSummary>
                <AccordionDetails
                  style={{ display: "flex", flexDirection: "column" }}
                >
                  <Typography variant="h3">Itens do Pedido</Typography>
                  <Divider style={{ marginBottom: "0.75rem" }} />
                  {item?.ProdutosFormat?.map((product) => {
                    return (
                      <>
                        <Grid
                          item
                          xs={12}
                          style={{
                            display: "flex",
                            flexDirection: isMobile500 ? "column" : "row",
                          }}
                        >
                          <Grid
                            item
                            xs={2}
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <ImagePlaceholder
                              src={product?.Foto}
                              alt="Foto do produto"
                              width={50}
                              widthOnError={40}
                              imagePreviewTitle={`Produto ${product?.IdProduto}`}
                            />
                          </Grid>
                          <Grid item xs={isMobile500 ? 12 : 10}>
                            <Typography
                              variant="body2"
                              style={{ fontWeight: "650" }}
                            >
                              {product?.DescricaoProduto}
                            </Typography>
                            <Typography
                              variant="body2"
                              style={{
                                fontSize: "0.85rem",
                                margin: "0.4rem 0",
                              }}
                            >
                              Quantidade: {product?.QuantidadePedida}
                            </Typography>
                            <Typography
                              variant="body2"
                              style={{
                                fontSize: "0.85rem",
                                margin: "0.4rem 0",
                              }}
                            >
                              Código: {product?.IdProduto}
                            </Typography>
                            <Typography
                              variant="body2"
                              style={{ fontSize: "0.85rem" }}
                            >
                              EAN: {product?.Ean}
                            </Typography>
                          </Grid>
                        </Grid>
                        <Divider style={{ margin: "0.7rem 0" }} />
                      </>
                    );
                  })}
                </AccordionDetails>
              </Accordion>
            ))}
          </Grid>
        </Card>
      </Grid>
    </Grid>
  );
}
